<div class="app-container">
  <!--  <loading-spinner [isLoading]="loading" [classesString]="'top-50'"></loading-spinner>-->
  <page-header
    [icon]="'far-file-check'"
    [title]="'inventory.detail'"
    [appendNoTranslationTitlePart]="
      inventoryExport?.date ? (inventoryExport.date | strToDate | date: 'dd.MM.yyyy') : ''
    "
  >
    <ng-container class="back-button">
      <btn
        [label]="'back'"
        [title]="'back' | translate"
        [isBackButton]="true"
        [classes]="['btn-third', 'float-right', 'mr-2']"
        [icon]="'far-arrow-left'"
        (onEvent)="triggerBackBtn()"
      >
      </btn>
    </ng-container>
  </page-header>
  <i class="fa-solid fa-rotate-right"></i>

  <section class="content" *ngIf="inventoryExport">
    <div class="row">
      <div class="col-12 col-md-6 d-flex">
        <div class="card info-card w-100">
          <h3 class="card-title mb-2">
            {{ 'info' | translate }}
          </h3>
          <div class="table-responsive">
            <table class="table m-0">
              <tbody>
                <tr>
                  <td class="pl-0 card-subheading no-hover">
                    {{ 'status' | translate }}
                  </td>
                  <td class="text-right no-hover">
                    <span class="badge badge-light" *ngIf="!inventoryExport.approved && !inventoryExport.rejected">
                      {{ 'waiting' | translate }}
                    </span>
                    <span class="badge badge-success" *ngIf="inventoryExport.approved">
                      {{ 'inventory.approved' | translate }}
                    </span>
                    <span class="badge badge-danger" *ngIf="inventoryExport.rejected">
                      {{ 'inventory.rejected' | translate }}
                    </span>
                  </td>
                </tr>
                <tr>
                  <td class="pl-0 card-subheading no-hover">
                    {{ 'reports.dateCreated' | translate }}
                  </td>
                  <td class="text-right no-hover">
                    {{
                      inventoryExport.created ? (inventoryExport.created | strToDate | date: 'dd.MM.yyyy HH:mm') : ''
                    }}
                  </td>
                </tr>
                <tr>
                  <td class="pl-0 card-subheading no-hover">
                    {{ 'reports.date.state' | translate }}
                  </td>
                  <td class="text-right no-hover">
                    {{ inventoryExport.date ? (inventoryExport.date | strToDate | date: 'dd.MM.yyyy') : '' }}
                  </td>
                </tr>
                <tr *ngIf="inventoryExport.approved">
                  <td class="pl-0 card-subheading no-hover">
                    {{ 'reports.dateApproved' | translate }}
                  </td>
                  <td class="text-right no-hover">
                    {{
                      inventoryExport.approved ? (inventoryExport.approved | strToDate | date: 'dd.MM.yyyy HH:mm') : ''
                    }}
                  </td>
                </tr>
                <tr *ngIf="inventoryExport.rejected">
                  <td class="pl-0 card-subheading no-hover">
                    {{ 'reports.dateRejected' | translate }}
                  </td>
                  <td class="text-right no-hover">
                    {{
                      inventoryExport.rejected ? (inventoryExport.rejected | strToDate | date: 'dd.MM.yyyy HH:mm') : ''
                    }}
                  </td>
                </tr>
                <tr *ngIf="inventoryExport.depots && inventoryExport.depots.length > 0">
                  <td class="pl-0 card-subheading no-hover">
                    {{ 'reports.depots' | translate }}
                  </td>
                  <td class="text-right no-hover">
                    <span class="label label-default" *ngFor="let depot of inventoryExport.depots">
                      {{ depot.name }}
                    </span>
                  </td>
                </tr>
                <tr *ngIf="inventoryExport.producers && inventoryExport.producers.length > 0">
                  <td class="pl-0 card-subheading no-hover">
                    {{ 'brands' | translate }}
                  </td>
                  <td class="text-right no-hover">
                    <span class="label label-default" *ngFor="let producer of inventoryExport.producers">
                      {{ producer.name }}
                    </span>
                  </td>
                </tr>
                <tr *ngIf="!isGeneratedFinal()">
                  <td class="pl-0 card-subheading no-hover">
                    {{ 'inventory.file.generated.1' | translate }}
                  </td>
                  <td class="text-right no-hover">
                    <btn
                      [label]="'download'"
                      [title]="'download' | translate"
                      [classes]="['btn-first', 'btn-sm', 'mr-2']"
                      [icon]="'fa-download'"
                      (onEvent)="downloadGenerated()"
                      *ngIf="!loading && inventoryExport.generated"
                    ></btn>
                    <btn
                      *ngIf="
                        inventoryExport.files?.length === 0 && !inventoryExport.approved && !inventoryExport.rejected
                      "
                      [classes]="['btn-third', 'btn-sm']"
                      [btnDisabled]="!inventoryExport?.generated"
                      (click)="regenerateExportXlsx()"
                      [icon]="!inventoryExport?.generated ? 'fa-spinner' : 'fa-sync-alt'"
                      [iconSpinning]="!inventoryExport?.generated"
                    ></btn>
                  </td>
                </tr>
                <tr *ngIf="inventoryExport.generated && !inventoryExport.approved && !inventoryExport.rejected">
                  <td class="pl-0 card-subheading no-hover" colspan="2">
                    {{ 'inventory.file.upload' | translate }}
                  </td>
                </tr>
                <tr *ngIf="inventoryExport.generated && !inventoryExport.approved && !inventoryExport.rejected">
                  <td class="text-right no-hover pl-0" colspan="2">
                    <form-row-input
                      [icon]="'fa-upload'"
                      [inputType]="'file'"
                      (valueChangeNative)="handleFileUpload($event)"
                    ></form-row-input>
                  </td>
                </tr>
                <tr *ngIf="isGeneratedFinal()">
                  <td class="pl-0 card-subheading no-hover">
                    {{ 'inventory.file.generated.2' | translate }}
                  </td>
                  <td class="text-right no-hover">
                    <btn
                      [label]="'download'"
                      [title]="'download' | translate"
                      [classes]="['btn-first', 'btn-sm']"
                      [icon]="'fa-download'"
                      (onEvent)="downloadGeneratedFinal()"
                      *ngIf="inventoryExport.generated"
                    ></btn>
                    <button class="btn btn-second btn-sm ml-2" *ngIf="!inventoryExport.generated" disabled>
                      <i class="fa fa-spinner fa-spin margin-right"></i>
                      {{ 'reports.generating' | translate }}
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div>
            <alert type="danger" *ngIf="error">
              {{ 'print-inventory.error' | translate }}
            </alert>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-6 d-flex" *ngIf="isRightBlockShown">
        <!--        *ngIf="inventoryExport.generated && inventoryExport.url?.length && inventoryExport.files?.length"-->
        <div class="card info-card w-100">
          <h3 class="card-title mb-2">
            {{ 'inventory.title.action' | translate }}
          </h3>
          <div class="d-flex flex-row flex-wrap gap-2">
            <div class="margin-bottom mr-2" *ngIf="!inventoryExport.approved && !inventoryExport.rejected">
              <btn
                [btnDisabled]="!hasRoleInventoryApprove"
                [label]="'inventory.btn.approve'"
                [title]="'inventory.btn.approve' | translate"
                [classes]="['btn-first', 'btn-lg']"
                [icon]="'fa fa-check-square'"
                (onEvent)="approveInventory()"
              ></btn>
            </div>
            <div class="margin-bottom mr-2" *ngIf="!inventoryExport.approved && !inventoryExport.rejected">
              <btn
                [btnDisabled]="!hasRoleInventoryApprove"
                [label]="'inventory.btn.reject'"
                [title]="'inventory.btn.reject' | translate"
                [classes]="['btn-first-red', 'btn-lg']"
                [icon]="'far-trash-alt'"
                (onEvent)="rejectInventory()"
              ></btn>
            </div>
            <!--            todo: redundant btns. dont show:-->
            <!--            <div class="margin-bottom mr-2" *ngIf="inventoryExport.approved">-->
            <!--              <btn-->
            <!--                [label]="'inventory.approved'"-->
            <!--                [title]="'inventory.approved' | translate"-->
            <!--                [classes]="['btn-first', 'btn-lg']"-->
            <!--                [icon]="'fa fa-check-square'"-->
            <!--                [btnDisabled]="true"-->
            <!--              ></btn>-->
            <!--            </div>-->
            <!--            <div class="margin-bottom mr-2" *ngIf="inventoryExport.rejected">-->
            <!--              <btn-->
            <!--                [label]="'inventory.rejected'"-->
            <!--                [title]="'inventory.rejected' | translate"-->
            <!--                [classes]="['btn-first-red', 'btn-lg']"-->
            <!--                [icon]="'far-trash-alt'"-->
            <!--                [btnDisabled]="true"-->
            <!--              ></btn>-->
            <!--            </div>-->

            <div
              *ngIf="
                inventoryExport.approved &&
                !inventoryExport.finished &&
                !inventoryExport.pmpIn &&
                !inventoryExport.pmpOut
              "
              class="margin-bottom mr-2"
            >
              <!--                !this.isGeneratedPmps()-->
              <button class="btn btn-second" disabled>
                <i class="fa fa-spinner fa-spin margin-right"></i>
                {{ 'reports.generating' | translate }}
              </button>
            </div>
            <div
              class="margin-bottom mr-2"
              *ngIf="
                inventoryExport.approved &&
                inventoryExport.pmpIn &&
                inventoryExport.pmpIn.url &&
                inventoryExport.pmpIn.url.length > 0
              "
            >
              <btn
                [label]="'download.pmp.in'"
                [title]="'download.pmp.in' | translate"
                [classes]="['btn-first', 'btn-lg']"
                [icon]="'fa-download'"
                (onEvent)="downloadProductMovePack(inventoryExport.pmpIn, 'in')"
              ></btn>
            </div>
            <!--              <div *ngIf="inventoryExport.finished && !inventoryExport.pmpIn" class="margin-bottom">-->
            <!--                {{'deleted.pmp.in' | translate}}-->
            <!--              </div>-->
            <div
              class="margin-bottom mr-2"
              *ngIf="
                inventoryExport.approved &&
                inventoryExport.pmpOut &&
                inventoryExport.pmpOut.url &&
                inventoryExport.pmpOut.url.length > 0
              "
            >
              <btn
                [label]="'download.pmp.out'"
                [title]="'download.pmp.out' | translate"
                [classes]="['btn-first']"
                [icon]="'fa-download'"
                (onEvent)="downloadProductMovePack(inventoryExport.pmpOut, 'out')"
              ></btn>
            </div>
            <!--              <div *ngIf="inventoryExport.finished && !inventoryExport.pmpOut" class="margin-bottom">-->
            <!--                {{'deleted.pmp.out' | translate}}-->
            <!--              </div>-->
          </div>
        </div>
      </div>
    </div>
  </section>
  <section>
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-12">
            <div>
              <h3 class="inventory-wizard-heading">{{ 'inventory.wizard.heading' | translate }}</h3>
              <div class="inventory-wizard-step-container">
                <div
                  class="inventory-wizard-step"
                  [ngClass]="{ active: wizardActiveStep === 1, completed: wizardActiveStep > 1 }"
                >
                  <div class="inventory-wizard-step-point-container">
                    <div class="inventory-wizard-step-point">
                      <i class="fas fa-check-circle" *ngIf="wizardActiveStep !== 1"></i>
                      <span *ngIf="wizardActiveStep === 1 || wizardActiveStep < 1">1</span>
                    </div>
                  </div>
                  <h4>{{ 'inventory.wizard.step1.heading' | translate }}</h4>
                  <p>{{ 'inventory.wizard.step1.description' | translate }}</p>
                </div>
                <div
                  class="inventory-wizard-step"
                  [ngClass]="{ active: wizardActiveStep === 2, completed: wizardActiveStep > 2 }"
                >
                  <div class="inventory-wizard-step-point-container">
                    <div class="inventory-wizard-step-point">
                      <i class="fas fa-check-circle" *ngIf="wizardActiveStep > 2"></i>
                      <span *ngIf="wizardActiveStep === 2 || wizardActiveStep < 2">2</span>
                    </div>
                  </div>
                  <h4>{{ 'inventory.wizard.step2.heading' | translate }}</h4>
                  <p>{{ 'inventory.wizard.step2.description' | translate }}</p>
                </div>
                <div
                  class="inventory-wizard-step"
                  [ngClass]="{ active: wizardActiveStep === 3, completed: wizardActiveStep > 3 }"
                >
                  <div class="inventory-wizard-step-point-container">
                    <div class="inventory-wizard-step-point">
                      <i class="fas fa-check-circle" *ngIf="wizardActiveStep > 3"></i>
                      <span *ngIf="wizardActiveStep === 3 || wizardActiveStep < 3">3</span>
                    </div>
                  </div>
                  <h4>{{ 'inventory.wizard.step3.heading' | translate }}</h4>
                  <p>{{ 'inventory.wizard.step3.description' | translate }}</p>
                </div>
                <div
                  class="inventory-wizard-step"
                  [ngClass]="{ active: wizardActiveStep === 4, completed: wizardActiveStep > 4 }"
                >
                  <div class="inventory-wizard-step-point-container">
                    <div class="inventory-wizard-step-point">
                      <i class="fas fa-check-circle" *ngIf="wizardActiveStep > 4"></i>
                      <span *ngIf="wizardActiveStep === 4 || wizardActiveStep < 4">4</span>
                    </div>
                  </div>
                  <h4>{{ 'inventory.wizard.step4.heading' | translate }}</h4>
                  <p>{{ 'inventory.wizard.step4.description' | translate }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>
